import {
  actionTypes,
  ChangePasswordActions,
  ChangePasswordState,
  ChangePasswordStatus,
  CheckTokenStatus,
  initialState,
} from './types'

const ChangePasswordReducer = (
  state: ChangePasswordState = initialState,
  action?: ChangePasswordActions
): ChangePasswordState => {
  switch (action?.type) {
    case actionTypes.CHECK_TOKEN_FETCH:
      return {
        ...state,
        token: action?.payload?.token,
        checkTokenStatus: CheckTokenStatus.Loading,
      }
    case actionTypes.CHECK_TOKEN_SUCCESS:
      return {
        ...state,
        checkTokenResult: action?.payload?.result,
        checkTokenStatus: CheckTokenStatus.Success,
      }
    case actionTypes.CHECK_TOKEN_ERROR:
      return {
        ...state,
        checkTokenStatus: CheckTokenStatus.Error,
      }
    case actionTypes.CHECK_TOKEN_RESET:
      return {
        ...state,
        checkTokenResult: null,
        token: null,
        checkTokenStatus: CheckTokenStatus.Idle,
      }
    case actionTypes.CHANGE_PASSWORD_FETCH:
      return {
        ...state,
        token: action?.payload?.token,
        changePasswordStatus: ChangePasswordStatus.Loading,
      }
    case actionTypes.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePasswordStatus: ChangePasswordStatus.Success,
      }
    case actionTypes.CHANGE_PASSWORD_EXPIRED_TOKEN:
      return {
        ...state,
        changePasswordStatus: ChangePasswordStatus.ExpiredToken,
      }
    case actionTypes.CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        changePasswordStatus: ChangePasswordStatus.Error,
      }
    case actionTypes.CHANGE_PASSWORD_RESET:
      return {
        ...state,
        token: null,
        changePasswordStatus: ChangePasswordStatus.Idle,
      }
    default:
      return state
  }
}

export default ChangePasswordReducer
